module.exports = __webpack_public_path__ + "assets/folder-active.c2492aa1.svg";